var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "maren-sol" },
        [
          _c("el-container", { staticClass: "d-flex-column" }, [
            _c("h1", [
              _vm._v("Awards & "),
              _c("span", { staticClass: "d-block" }, [_vm._v("Events")])
            ]),
            _c("p", [
              _vm._v(
                "The main goal of maren solutions is to encourage the employees  "
              ),
              _c("span", { staticClass: "d-block" }, [
                _vm._v(
                  " and ensuure they are secured and feel stress- free, We do have "
                )
              ]),
              _vm._v(
                " our unique activities to motivate the employees and are proud"
              ),
              _c("span", { staticClass: "d-block" }, [
                _vm._v(
                  " to say that we belong to 100% employee friendly company category"
                )
              ])
            ]),
            _c("ul", { staticClass: "newlist" }, [
              _c("li", [_vm._v("Employee of the month")]),
              _c("li", [_vm._v("Employee of the year")]),
              _c("li", [_vm._v("100% attendance")]),
              _c("li", [_vm._v("Star performer of the week ")]),
              _c("li", [_vm._v("Punctuality award")]),
              _c("li", [_vm._v("Team outings")])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-container",
        { staticClass: "d-flex-column p-t50" },
        [
          _c(
            "el-row",
            { staticClass: "careers-grid", attrs: { gutter: 30 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("h2", [_vm._v("Company Culture")]),
                _c("p", [
                  _vm._v(
                    "We care about our employees and their personal life. We ensure every employee in our organisation maintains healthy work-life balance.  We follow right mindedness corporate ethics and adhere to  zero politics atmosphere.\nWe listen, care and react to our employees concerns and feedbacks. We also have friday fun activites to burn out the stress out the employees."
                  )
                ])
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("img", {
                  staticClass: "img-responsive",
                  attrs: {
                    src: require("../../../public/img/careers/company-culture.png"),
                    alt: "Careers"
                  }
                })
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/static/AwardsEvents.vue?vue&type=template&id=811adb34&
// module id = 569
// module chunks = 6